/* eslint-disable import/no-anonymous-default-export */
export default {
  head: "اختر الشركة",
  selectAll: "اختر جميع الشركات",
  done: "منتهي",
};
